import React from 'react';
import { MdClear, MdDone } from 'react-icons/md';
import classNames from 'classnames';

import { Icon } from '../../components/icon';

type PasswordStrengthIndicatorProps = {
  value: string;
  passwordRequirements: { regexp: RegExp; description: string }[];
};
export const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> =
  ({ value, passwordRequirements }) => (
    <ul>
      {passwordRequirements.map(({ regexp, description }) => {
        const matches = regexp.test(value);

        return (
          <li
            key={description}
            className={classNames(
              matches ? 'text-emerald-500' : 'text-red-500'
            )}
          >
            <Icon
              className="inline-block mr-2"
              icon={matches ? <MdDone /> : <MdClear />}
            />

            {description}
          </li>
        );
      })}
    </ul>
  );
